export default {
    title: 'Title',
    macrotrends: 'Macro-trends',
    description: 'Description',

    validation: {
        title: {
            required: 'Please add title of innovation project',
            length: 'The title should not contain more than 100 characters'
        },
        description: {
            required: 'Please add description',
            length: 'The description should not be longer than 1000 characters'
        },
        image: {
            size: 'The image must not be larger than 8MB',
            mimetype: 'Please use GIF/JPG/PNG only'
        }
    },

    cancel: 'Cancel',
    submit: 'Submit',
    success: 'The innovation project was created successfully'
}
